var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpportunitiesForMonetization(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.0828 175C55.2883 174.271 52.6051 173.309 50.3859 171.358C46.5761 168.01 44.8453 163.773 45.0145 158.758C45.1451 154.83 45.9525 151.033 47.3545 147.357C51.0434 137.666 54.7275 127.974 58.3777 118.269C60.1521 113.549 63.4639 110.612 68.463 110.051C73.6555 109.467 77.6829 111.65 80.3468 116.158C80.8593 117.027 81.4249 117.317 82.4209 117.312C94.1451 117.278 105.874 117.278 117.598 117.312C118.59 117.312 119.16 117.037 119.673 116.162C122.332 111.641 126.364 109.481 131.552 110.046C136.502 110.587 139.829 113.481 141.593 118.124C145.311 127.912 149.029 137.699 152.708 147.497C154.386 151.97 155.353 156.579 154.869 161.386C154.202 168.043 149.3 173.372 142.734 174.71C142.459 174.768 142.202 174.904 141.932 175H137.242C132.456 174.005 129.013 170.763 125.349 167.898C121.771 165.101 118.198 162.304 114.644 159.483C114.117 159.062 113.605 158.864 112.923 158.869C104.327 158.889 95.7309 158.889 87.1348 158.869C86.3951 158.869 85.8487 159.111 85.2927 159.555C82.6578 161.657 80.0519 163.792 77.3444 165.787C72.6354 169.246 68.6371 173.87 62.4776 175.005H58.078L58.0828 175ZM81.101 134.791C78.6595 134.791 76.2131 134.772 73.7716 134.796C71.2043 134.825 69.3139 136.598 69.2317 138.999C69.1495 141.41 71.0786 143.395 73.699 143.424C78.5338 143.477 83.3733 143.477 88.2129 143.424C90.843 143.395 92.7624 141.415 92.6802 138.999C92.598 136.588 90.7125 134.825 88.1404 134.796C85.7956 134.772 83.4507 134.791 81.1059 134.791H81.101ZM108.814 143.429C111.25 143.429 113.238 141.458 113.204 139.071C113.175 136.724 111.246 134.825 108.877 134.796C106.435 134.767 104.433 136.685 104.409 139.081C104.385 141.463 106.377 143.434 108.814 143.429ZM126.456 143.429C128.888 143.405 130.865 141.4 130.792 139.018C130.725 136.661 128.796 134.801 126.417 134.796C123.985 134.786 121.988 136.748 122.003 139.129C122.017 141.521 124.014 143.448 126.456 143.429Z",
    fill: "url(#paint0_linear_75_63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.587 64.5327C139.587 86.3933 121.892 104.09 100.024 104.094C78.1518 104.094 60.4373 86.4078 60.4325 64.5569C60.4325 42.6334 78.1615 24.9759 100.145 25C121.911 25.0242 139.582 42.7397 139.582 64.5327H139.587ZM102.949 50.7352C103.877 50.8318 104.385 51.3101 104.946 51.682C106.445 52.6869 108.147 52.4888 109.123 51.2038C110.148 49.8511 109.848 48.136 108.34 46.9669C107.175 46.0587 105.884 45.2954 104.453 44.991C103.186 44.7205 102.882 44.1359 102.915 42.9233C102.969 41.044 101.702 39.6962 100.077 39.6527C98.4094 39.6044 97.0315 40.9957 97.1137 42.9378C97.1668 44.2277 96.7656 44.735 95.5424 45.1891C91.4764 46.6915 89.3442 49.8462 88.9236 54.0493C88.5223 58.0591 90.1565 61.1703 93.7342 63.1703C94.5851 63.6438 95.4408 64.1124 96.3111 64.552C96.7704 64.7839 97.0943 65.0061 97.0895 65.6197C97.0605 69.673 97.0605 73.7262 97.0895 77.7795C97.0895 78.5332 96.7801 78.4945 96.1951 78.3979C94.7543 78.1515 93.5795 77.3689 92.3466 76.678C90.785 75.8036 89.1025 76.2287 88.2661 77.6442C87.4732 78.9873 87.889 80.6298 89.3104 81.5961C91.0171 82.7603 92.8398 83.8377 94.8945 84.0213C96.7075 84.1807 97.2345 84.8087 97.1475 86.5866C97.0653 88.2291 98.5592 89.4755 100.077 89.4369C101.547 89.3982 102.761 88.205 102.935 86.6107C102.973 86.2725 102.998 85.9199 102.949 85.5865C102.78 84.4561 103.196 83.944 104.337 83.5237C109.094 81.7555 112.213 76.9969 112.15 71.8856C112.092 67.0159 109.404 63.465 104.322 61.5568C104.139 61.4891 103.964 61.378 103.781 61.3442C103.138 61.2138 102.944 60.8369 102.949 60.1992C102.978 57.0784 102.964 53.9575 102.964 50.74L102.949 50.7352Z",
    fill: "url(#paint1_linear_75_63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.998 77.8034V67.4746C104.931 67.9964 106.145 69.3925 106.314 71.6148C106.508 74.2043 105.367 76.2044 102.998 77.8034Z",
    fill: "url(#paint2_linear_75_63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0701 58.305C93.9372 56.6189 93.9275 53.1212 96.9106 50.9473C97.2248 52.1647 97.0218 53.3531 97.0604 54.5223C97.0991 55.7252 97.0701 56.9233 97.0701 58.305Z",
    fill: "url(#paint3_linear_75_63)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_63",
    x1: 99.9986,
    y1: 109.958,
    x2: 99.9986,
    y2: 175.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_63",
    x1: 100.01,
    y1: 25,
    x2: 100.01,
    y2: 104.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_75_63",
    x1: 104.666,
    y1: 67.4746,
    x2: 104.666,
    y2: 77.8034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_75_63",
    x1: 95.8931,
    y1: 50.9473,
    x2: 95.8931,
    y2: 58.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_63"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 150,
    fill: "white",
    transform: "translate(45 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpportunitiesForMonetization);
export default __webpack_public_path__ + "static/media/Opportunities_for_Monetization.5979af5eb4fd8cd98dac9d7c8d197298.svg";
export { ForwardRef as ReactComponent };